import {
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Tooltip,
  Typography
} from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import { getUser, openBlob } from 'src/utils/Common';
import { loadUrunControlDetail } from 'src/utils/storage/StartWorkOrder';

const useStyles = makeStyles(theme => ({
  root: {},
  dividerB: {
    backgroundColor: '#1D3343'
  }
}));

function BulletinControl({ className, FisNo, readonly, tasks, ...rest }) {
  const classes = useStyles();
  const { t } = useTranslation('product_detail_control');
  const [BultenDataControl, setBultenDataControl] = useState([]);
  const SessionUserControl = getUser();
  const BirimKoduControl = SessionUserControl.ServiceShopId;
  const TeknisyenKoduControl = SessionUserControl.TechnicianId;
  const [LoadingControl, setLoadingControl] = useState(true);
  const DataControl = loadUrunControlDetail();
  const ModelControl =
    DataControl && DataControl[0] && DataControl[0].KUL_MODEL_KODU;

  useEffect(() => {
    let mountedControl = true;
    const fetchTodosControl = () => {
      let ModelParamControl = '-1';
      if (ModelControl !== '') {
        ModelParamControl = ModelControl;
      }
      axios
        .get(
          `/GetSiriusBulletin/${BirimKoduControl}/${TeknisyenKoduControl}/${ModelParamControl}`
        )
        .then(response => {
          if (mountedControl) {
            const DegerControl = response.data === '' ? [] : response.data;
            setBultenDataControl(DegerControl);
            setLoadingControl(false);
          }
        })
        .catch(error => {
          setLoadingControl(false);
        });
    };
    fetchTodosControl();
    return () => {
      mountedControl = false;
    };
  }, [BirimKoduControl, TeknisyenKoduControl, ModelControl]);

  const BultenDetayAcControl = logControl => {
    setLoadingControl(true);
    const dataBultenDetayControl = {
      ServiceShopId: SessionUserControl.ServiceShopId,
      UserId: SessionUserControl.UserId,
      FilePtr: logControl.FP
    };
    const configControl = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post(
        '/FileImportExport/SiriusBulletin',
        dataBultenDetayControl,
        configControl
      )
      .then(response => {
        openBlob(
          response.data,
          `${logControl.BT}_${logControl.AY}_${logControl.BN}`
        );
        setLoadingControl(false);
      })
      .catch(error => {
        setLoadingControl(false);
      });
  };

  const userControl = getUser();
  const user_typesControl = userControl.TechnicianType.split(',');
  let klima_teknisyeniControl = false;
  user_typesControl &&
    user_typesControl.forEach(u => {
      if (parseInt(u) === 26) {
        klima_teknisyeniControl = true;
      }
    });
  if (klima_teknisyeniControl) {
    return (
      <Card>
        <CardHeader title={t('Yetki_Kontrolu')} />
        <Divider />
        <CardContent>{t('Yetki_Mesaji')}</CardContent>
      </Card>
    );
  }
  return (
    <Card className={clsx(classes.root, className)}>
      <CardHeader title={t('Bulten_title')} />
      <Divider />
      <CardContent>
        <div className={classes.inner}>
          {LoadingControl ? (
            <CircularProgress status="loading" style={{ marginLeft: '50%' }} />
          ) : (
            BultenDataControl.map(log => (
              <div key={log.BN}>
                <List className={classes.root}>
                  <ListItem alignItems="flex-start">
                    <ListItemAvatar>
                      <div>
                        <Typography
                          component="span"
                          variant="h3"
                          className={classes.inline}
                          color="textPrimary"
                        >
                          {log.GUN}
                        </Typography>
                        <br />
                        <Typography
                          component="span"
                          variant="subtitle1"
                          className={classes.inline}
                          color="textPrimary"
                        >
                          {log.AY.substring(0, 3)}
                        </Typography>
                        <br />
                        <Typography
                          component="span"
                          variant="subtitle1"
                          className={classes.inline}
                          color="textPrimary"
                        >
                          {log.YIL}
                        </Typography>
                        <br />
                      </div>
                    </ListItemAvatar>
                    <ListItemText
                      primary={log.BT}
                      secondary={
                        <>
                          <Typography
                            component="span"
                            variant="body2"
                            className={classes.inline}
                            color="textPrimary"
                          >
                            {log.A}
                          </Typography>
                        </>
                      }
                    />
                    <ListItemSecondaryAction>
                      <Tooltip title="Bülten Göster">
                        <IconButton
                          color="primary"
                          edge="end"
                          onClick={() => BultenDetayAcControl(log)}
                          size="small"
                        >
                          <CloudDownloadIcon />
                        </IconButton>
                      </Tooltip>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider className={classes.dividerB} />
                </List>
              </div>
            ))
          )}
        </div>
      </CardContent>
    </Card>
  );
}

BulletinControl.propTypes = {
  className: PropTypes.string
};

export default connect(state => ({ tasks: state.tasks1 }))(BulletinControl);
